interface GearsWithArrowsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearsWithArrowsSVG = ({ color, style }: GearsWithArrowsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="52"
    viewBox="0 0 41 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1477_5200)">
      <path
        d="M13.4776 42.4784C8.42836 40.1978 4.61336 35.6647 3.31738 30.1582"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2909 37.8726L13.4775 42.4786L8.9472 43.9317"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5429 12.8838C36.9077 16.2977 39.5389 21.605 39.4941 27.2602"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.6103 17.647L32.5429 12.8838L37.2949 12.5332"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2553 15.3806C26.2553 14.6541 26.1795 13.9444 26.0505 13.2543L28.9707 10.8868C28.6481 9.86287 28.2189 8.85583 27.6607 7.88805C27.1024 6.92028 26.4432 6.04507 25.7195 5.25402L22.2075 6.60049C21.1331 5.6776 19.8876 4.95667 18.5243 4.47699L17.9352 0.760177C16.8861 0.52735 15.8005 0.395508 14.6841 0.395508C13.5676 0.395508 12.4792 0.52735 11.4329 0.760177L10.8438 4.47699C9.48052 4.95667 8.23504 5.6804 7.16067 6.60049L3.64862 5.25402C2.92209 6.04507 2.26569 6.92028 1.70746 7.88805C1.14924 8.85583 0.720053 9.86287 0.397461 10.8868L3.31762 13.2543C3.18858 13.9444 3.11284 14.6541 3.11284 15.3806C3.11284 16.1071 3.18858 16.8168 3.31762 17.5069L0.397461 19.8744C0.720053 20.8983 1.14924 21.9054 1.70746 22.8731C2.26569 23.8409 2.9249 24.7161 3.64862 25.5072L7.16067 24.1607C8.23504 25.0836 9.48052 25.8045 10.8438 26.2842L11.4329 30.001C12.482 30.2338 13.5676 30.3657 14.6841 30.3657C15.8005 30.3657 16.8889 30.2338 17.9352 30.001L18.5243 26.2842C19.8876 25.8045 21.1331 25.0808 22.2075 24.1607L25.7195 25.5072C26.446 24.7161 27.1024 23.8409 27.6607 22.8731C28.2189 21.9054 28.6481 20.8983 28.9707 19.8744L26.0505 17.5069C26.1795 16.8168 26.2553 16.1071 26.2553 15.3806Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.321 37.5747L37.5046 37.1371C37.3251 36.6349 37.1035 36.1412 36.8286 35.6644C36.5509 35.1875 36.2311 34.7499 35.8832 34.346L36.8959 31.6811C36.2928 31.1341 35.6308 30.6375 34.893 30.214C34.1581 29.7932 33.3923 29.4706 32.6152 29.2266L30.8256 31.4482C29.7708 31.2547 28.6768 31.2547 27.6025 31.4595L25.7987 29.249C25.0217 29.4959 24.2615 29.8241 23.5294 30.2504C22.7972 30.6768 22.1352 31.1761 21.5349 31.7288L22.5644 34.3908C21.8547 35.224 21.3133 36.1721 20.9599 37.1876L18.1463 37.642C17.9724 38.4387 17.8742 39.2606 17.877 40.1077C17.877 40.9549 17.9808 41.7796 18.1603 42.5734L20.9767 43.011C21.1562 43.5132 21.3778 44.0069 21.6527 44.4837C21.9304 44.9606 22.2502 45.3982 22.5981 45.8022L21.5854 48.4671C22.1885 49.0141 22.8505 49.5106 23.5883 49.9341C24.3232 50.3549 25.089 50.6775 25.8661 50.9216L27.6557 48.6999C28.7105 48.8934 29.8045 48.8934 30.8789 48.6887L32.6826 50.8991C33.4596 50.6523 34.2198 50.3241 34.9519 49.8977C35.6841 49.4713 36.3461 48.972 36.9464 48.4194L35.9169 45.7601C36.6266 44.927 37.168 43.9788 37.5214 42.9634L40.335 42.5089C40.5089 41.7123 40.6071 40.8904 40.6043 40.0432C40.6043 39.196 40.5005 38.3713 40.321 37.5775V37.5747Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1477_5200">
        <rect width="41" height="51.3145" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearsWithArrowsSVG;
